import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ATTACHED_FILES = FORM_FIELDS.EMPLOYEE.ATTACHED_FILES;

export const attachedFilesValidation = yup.object().shape({
  [ATTACHED_FILES.UPLOAD_PHOTO]: yup.object().shape({
    id: yup.number().required("id is required"),
    name: yup.string().required(),
    mimeType: yup.string().required(),
    fileId: yup.string().required(),
    documentId: yup.string().required(),
    documentType: yup.string().required(),
  }),

  [ATTACHED_FILES.UPLOAD_SEAL]: yup.object().shape({
    id: yup.number().required("id is required"),
    name: yup.string().required(),
    mimeType: yup.string().required(),
    fileId: yup.string().required(),
    documentId: yup.string().required(),
    documentType: yup.string().required(),
  }),

  [ATTACHED_FILES.UPLOAD_SIGNATURE]: yup.object().shape({
    id: yup.number().required("id is required"),
    name: yup.string().required(),
    mimeType: yup.string().required(),
    fileId: yup.string().required(),
    documentId: yup.string().required(),
    documentType: yup.string().required(),
  }),
});

export const otherAttachedFilesValidation = yup.object().shape({
  [ATTACHED_FILES.OTHER_DOC.UPLOAD_DOCUMENT]: yup
    .object()
    .shape({
      id: yup.number().required("File ID is required"),
      name: yup.string().required("File name is required"),
      mimeType: yup.string().required("MIME type is required"),
      fileId: yup.string().required("File ID is required"),
      documentId: yup.string().required("Document ID is required"),
      documentType: yup.string().required("Document type is required"),
    })
    .nullable()
    .required("Document is required"),
});

export type AttachedFilesFormDataType = yup.InferType<
  typeof attachedFilesValidation
>;
export type OtherAttachedFilesFormDataType = yup.InferType<
  typeof otherAttachedFilesValidation
>;
